import type { InputHTMLAttributes, ReactNode } from 'react';
import { mergeClassnames, Switch } from '@heathmont/moon-core-tw';
import useSite from '~/client/hooks/useSite';

type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'>;

type Props = InputProps & {
  leftLabel?: ReactNode;
  rightLabel?: ReactNode;
  checked?: boolean;
  onChange: (on: boolean) => void;
};

const Toggle: FC<Props> = ({
  checked = false,
  onChange,
  leftLabel,
  rightLabel,
}) => {
  const { isBitcasino } = useSite();
  return (
    <div className="inline-container gap-2">
      {leftLabel && (
        <p
          className={mergeClassnames(
            'text-moon-10-caption font-medium uppercase',
            checked ? 'text-bulma' : 'text-trunks',
          )}
        >
          {leftLabel}
        </p>
      )}

      <Switch
        data-testid="fun-mode-toggle"
        checked={!checked}
        onChange={() => onChange(!checked)}
        onBgColor={isBitcasino ? 'bg-popo' : 'bg-piccolo'}
        offBgColor="bg-trunks"
        size="xs"
      />

      {rightLabel && (
        <p
          className={mergeClassnames(
            'text-moon-10-caption font-medium uppercase',
            checked ? 'text-trunks' : 'text-bulma',
          )}
        >
          {rightLabel}
        </p>
      )}
    </div>
  );
};

export default Toggle;
